<template>
  <BaseLayout page-default-back-link="/nativeTab/news" pageTitle="完成录入资料">
    <ion-content class="certification-inputDataFulfill">
      <ProgressBar :data="data" />
      <div class="card f-1">
        <img class="logo-image" src="./assets/logo-56.png" alt />
        <div class="title m-t-45 m-b-60">恭喜您,完成录入资料</div>
        <ion-button class="w-100b m-b-60" expand="block" @click="toHome">开始试用</ion-button>
        <ion-button class="w-100b" shape="round" fill="outline" @click="toUploadDocuments">立即认证</ion-button>
      </div>
      <div class="label f-center">
        <span>试用期3天，完成认证后您将获得</span>
        <ion-label color="primary">3个月</ion-label>
        <span>面试使用期</span>
      </div>
    </ion-content>
  </BaseLayout>
</template>

<script>
import router from '@/router'
import * as yup from 'yup'
import { ref, reactive } from 'vue'
import { ProgressBar, Dialog } from '@/view/certification/components'
import formData from '@/view/certification/formData'
import { useRoute } from 'vue-router'
import { actionSheetController } from '@ionic/vue'
import progressBarFulfillImage from '@/view/certification/assets/progressBar-fulfill.png'
import progressBarProcessingImage from '@/view/certification/assets/progressBar-processing.png'
import progressBarNotStartedImage from '@/view/certification/assets/progressBar-notStarted.png'

export default {
  setup() {
    const route = new useRoute()

    const data = [
      {
        label: 'STEP 1',
        title: '注册账号',
        image: progressBarFulfillImage,
        btnText: '已完成',
        barClass: 'fulfill-bar',
        status: 'fulfill',
      },
      {
        label: 'STEP 2',
        title: '录入资料',
        image: progressBarFulfillImage,
        btnText: '已完成',
        barClass: 'fulfill-bar',
        status: 'fulfill',
      },
      {
        label: 'STEP 2',
        title: '完成录入',
        image: progressBarFulfillImage,
        btnText: '已完成',
        status: 'fulfill',
      },
    ]

    document.getElementsByTagName('title')[0].innerText = '录入完成'

    const toUploadDocuments = () => {
      if (route.query.userType === 'individual') {
        router.replace({
          path: '/certification/uploadDocumentsIndividual',
        })
      } else {
        router.replace({
          path: '/certification/uploadDocuments',
          query: { userType: route.query.userType, id: route.query.id },
        })
      }
    }
    const toHome = () => {
      router.replace('/')
    }
    return {
      data,
      toUploadDocuments,
      toHome,
    }
  },
  components: { ProgressBar },
}
</script>

<style lang="scss">
@import 'style.scss';

.certification-inputDataFulfill {
  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 75px 75px 60px;
    background-color: #fff;
  }
  .logo-image {
    width: 115px !important;
    height: 115px !important;
  }
  .title {
    font-size: 34px;
    color: #333333;
  }
  .label {
    color: #333333;
    font-size: 28px;
  }
}
</style>